import React from "react";
import ClientLayout from "../components/layout/ClientLayout";
import BetfairTopNav from "./top-nav-betfair";
const BetfairGamesDashboard = () => {
  return (
    <ClientLayout>
      <div style={{ paddingLeft: "10px", paddingRight: "10px" }}>
        <div class="card ExMainCardbundle">
          <div class="card-header">
            <BetfairTopNav></BetfairTopNav>
          </div>
          <div className="card-body exlobbybg">
            <div>
              <div className="left">
                <a href="/betfair-hold">
                  <div className="card" style={{ marginBottom: "0px" }}>
                    <div>
                      <img
                        src="/assets/images/bpstudio/bpimg1.png"
                        className="card-img-top"
                        alt="Hold'em"
                      />
                    </div>
                    <div className="card-body">
                      <h5 className="card-title">Hold'em</h5>
                    </div>
                  </div>
                </a>
              </div>
              <div className="left">
                <a href="/betfair-turbo-hold">
                  <div className="card" style={{ marginBottom: "0px" }}>
                    <div>
                      <img
                        src="/assets/images/bpstudio/bpimg2.jpg"
                        className="card-img-top"
                        alt="Turbo Hold'em"
                      />
                    </div>
                    <div className="card-body">
                      <h5 className="card-title">Turbo Hold'em</h5>
                    </div>
                  </div>
                </a>
              </div>
              <div className="left">
                <a href="/betfair-blackjack">
                  <div className="card" style={{ marginBottom: "0px" }}>
                    <div>
                      <img
                        src="/assets/images/bpstudio/bpimg3.png"
                        className="card-img-top"
                        alt="BlackJack"
                      />
                    </div>
                    <div className="card-body">
                      <h5 className="card-title">BlackJack</h5>
                    </div>
                  </div>
                </a>
              </div>
              <div className="left">
                <a href="/betfair-turbo-blackjack">
                  <div className="card" style={{ marginBottom: "0px" }}>
                    <div>
                      <img
                        src="/assets/images/bpstudio/bpimg4.jpg"
                        className="card-img-top"
                        alt="Turbo BlackJack"
                      />
                    </div>
                    <div className="card-body">
                      <h5 className="card-title">Turbo BlackJack</h5>
                    </div>
                  </div>
                </a>
              </div>
              <div className="left">
                <a href="/betfair-baccarat">
                  <div className="card" style={{ marginBottom: "0px" }}>
                    <div>
                      <img
                        src="/assets/images/bpstudio/bpimg5.jpg"
                        className="card-img-top"
                        alt="Baccarat"
                      />
                    </div>
                    <div className="card-body">
                      <h5 className="card-title">Baccarat</h5>
                    </div>
                  </div>
                </a>
              </div>
              <div className="left">
                <a href="/betfair-turbo-baccarat">
                  <div className="card" style={{ marginBottom: "0px" }}>
                    <div>
                      <img
                        src="/assets/images/bpstudio/bpimg6.jpg"
                        className="card-img-top"
                        alt="Turbo Baccarat"
                      />
                    </div>
                    <div className="card-body">
                      <h5 className="card-title">Turbo Baccarat</h5>
                    </div>
                  </div>
                </a>
              </div>
              <div className="left">
                <a href="/betfair-hilo">
                  <div className="card" style={{ marginBottom: "0px" }}>
                    <div>
                      <img
                        src="/assets/images/bpstudio/bpimg7.png"
                        className="card-img-top"
                        alt="Hi Lo"
                      />
                    </div>
                    <div className="card-body">
                      <h5 className="card-title">Hi Lo</h5>
                    </div>
                  </div>
                </a>
              </div>
              <div className="left">
                <a href="/betfair-turbo-hilo">
                  <div className="card" style={{ marginBottom: "0px" }}>
                    <div>
                      <img
                        src="/assets/images/bpstudio/bpimg8.png"
                        className="card-img-top"
                        alt="Turbo HiLo"
                      />
                    </div>
                    <div className="card-body">
                      <h5 className="card-title">Turbo HiLo</h5>
                    </div>
                  </div>
                </a>
              </div>
              <div className="left">
                <a href="/betfair-omaha">
                  <div className="card" style={{ marginBottom: "0px" }}>
                    <div>
                      <img
                        src="/assets/images/bpstudio/bpimg9.jpg"
                        className="card-img-top"
                        alt="Omaha Hi"
                      />
                    </div>
                    <div className="card-body">
                      <h5 className="card-title">Omaha Hi</h5>
                    </div>
                  </div>
                </a>
              </div>
              <div className="left">
                <a href="/betfair-derby">
                  <div className="card" style={{ marginBottom: "0px" }}>
                    <div>
                      <img
                        src="/assets/images/bpstudio/derby.jpg"
                        className="card-img-top"
                        alt="Derby Race"
                      />
                    </div>
                    <div className="card-body">
                      <h5 className="card-title">Derby Race</h5>
                    </div>
                  </div>
                </a>
              </div>
              <div className="left">
                <a href="/betfair-turbo-derby">
                  <div className="card" style={{ marginBottom: "0px" }}>
                    <div>
                      <img
                        src="/assets/images/bpstudio/derby-turbo-race.jpg"
                        className="card-img-top"
                        alt="Derby Race"
                      />
                    </div>
                    <div className="card-body">
                      <h5 className="card-title">Derby Turbo Race</h5>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div
            className="card-body mainexcard"
            id="Excardbody"
            style={{ display: "none" }}
          ></div>
        </div>
      </div>
    </ClientLayout>
  );
};

export default BetfairGamesDashboard;
